export const DISCONNECT_ASSET_REQUEST = 'gatewayManagement/DISCONNECT_ASSET_REQUEST';
export const DISCONNECT_ASSET = 'gatewayManagement/DISCONNECT_ASSET';
